<template>
  <b-row class="weight-adjustment-box no-gutters">
    <b-col class="reduce-padding" cols="12">
      <b-row class="no-gutters">
        <b-col class="reduce-padding" cols="12">
          
        </b-col>
        <b-col class="box-col reduce-padding" cols="12">
          <b-row class="no-gutters">
            <b-col class="reduce-padding" cols="12">
              <div class="title">{{$t('weightAdjBox.title1')}}<span v-if="condition"> {{$t('weightAdjBox.title2')}} {{disease}}</span>.<sup>*</sup></div>
            </b-col>
            <b-col class="reduce-padding" cols="12">
              <div class="adjust-box" :class="{'adjust-box-sp' : $i18n.locale=='sp'}"  >
                <b-row class="no-gutters">
                  <b-col :class="{'adj-box-top-text-sp' : $i18n.locale=='sp'}" class="lower-weight adj-box-top-text reduce-padding" cols="12">
                    <span v-show="show(adjButtons, 'twenty')">{{$t('weightAdjBox.lowerWeightBy')}}:</span>
                  </b-col>
                  <b-col class="reduce-padding" cols="6" v-if="!(disease==pageHypertension&&condition)">
                    
                    <!--4 btns-->
                    <b-row class="no-gutters flex-container" v-if="show(adjButtons, 'twenty')">
                      <b-col class="reduce-padding flex-item" cols="12">
                        <button @click="btnClickHandler();SetAdjustPerc(5);" class="adjust-btn" :class="{'clicked':adjustPerc===5}">
                          <span class="btn-text nxt-text">5%</span>
                        </button>
                      </b-col>
                      <b-col class="reduce-padding flex-item" cols="12">
                        <button @click="btnClickHandler();SetAdjustPerc(10);" class="adjust-btn" :class="{'clicked':adjustPerc===10}">
                          <span class="btn-text nxt-text">10%</span>
                        </button>
                      </b-col>
                      <b-col class="reduce-padding flex-item" cols="12">
                        <button @click="btnClickHandler();SetAdjustPerc(15);" class="adjust-btn" :class="{'clicked':adjustPerc===15}">
                          <span class="btn-text nxt-text">15%</span>
                        </button>
                      </b-col>
                      <b-col class="reduce-padding flex-item" cols="12">
                        <button @click="btnClickHandler();SetAdjustPerc(20);" class="adjust-btn" :class="{'clicked':adjustPerc===20}">
                          <span class="btn-text nxt-text">20%</span>
                        </button>
                      </b-col>
                    </b-row> 
                    
                    <!--2 btns-->
                    <b-row class="no-gutters flex-container" :class="{'flex-container-sp' : $i18n.locale=='sp'}" v-if="!show(adjButtons, 'twenty')">
                      <b-col :class="{'adj-box-top-text-sp' : $i18n.locale=='sp'}" class="flex-item adj-box-top-text lower-text lower-text2" cols="12">
                       {{$t('weightAdjBox.lowerWeightBy')}}:
                       </b-col>
                      <b-col class="reduce-padding flex-item" cols="12" v-if="show(adjButtons, 'five')" >
                        <button @click="btnClickHandler();SetAdjustPerc(5);" class="adjust-btn" :class="{'clicked':adjustPerc===5}">
                          <span class="btn-text nxt-text">5%</span>
                        </button>
                      </b-col>
                      <b-col class="reduce-padding flex-item" cols="12" v-if="show(adjButtons, 'ten')">
                        <button @click="btnClickHandler();SetAdjustPerc(10);" class="adjust-btn" :class="{'clicked':adjustPerc===10}">
                          <span class="btn-text nxt-text">10%</span>
                        </button>
                      </b-col>
                      <b-col class="reduce-padding flex-item" cols="12">
                      </b-col>
                    </b-row>  
                  </b-col>
                  
                  <b-col class="reduce-padding" cols="6" v-if="disease==pageHypertension &&condition">
                    <!--single btn-->
                    <b-row class="no-gutters flex-container" :class="{'flex-container-sp' : $i18n.locale=='sp'}"  v-if="!show(adjButtons, 'twenty')">
                      <b-col :class="{'adj-box-top-text-sp' : $i18n.locale=='sp'}" class="flex-item adj-box-top-text weightbox-xtras lower-text lower-text2" cols="12">
                       {{$t('weightAdjBox.lowerWeightBy')}}:
                       </b-col>
                      <b-col class="reduce-padding flex-item" cols="12" v-if="show(adjButtons, 'five')" >
                        <button @click="btnClickHandler();SetAdjustPerc(5);" class="adjust-btn" :class="{'clicked':adjustPerc===5}">
                          <span class="btn-text nxt-text">5%</span>
                        </button>
                      </b-col>
                      <b-col class="reduce-padding flex-item" cols="12">
                      </b-col>
                    </b-row>  
                  </b-col>
                  
                  <b-col class="reduce-padding" cols="6">
                    <div class="adj-value-section" :class="{'only5':disease==pageHypertension&&condition}">
                      <div class="adj-title">{{$t('weightAdjBox.adjWeight')}}:</div>
                      <div class="value-div">
                        <div v-if="adjustPerc==0" class="adj-value">--<span v-if="!(disease==pageNAFLD)">-</span></div>
                        <div v-if="adjustPerc==5" class="adj-value">{{userData.calc.weight.adj5}}</div>
                        <div v-if="adjustPerc==10" class="adj-value">{{userData.calc.weight.adj10}}</div>
                        <div v-if="adjustPerc==15" class="adj-value">{{userData.calc.weight.adj15}}</div>
                        <div v-if="adjustPerc==20" class="adj-value">{{userData.calc.weight.adj20}}</div>
                      </div>
                      <div class="blue-hr"></div>
                      <div class="adj-title">{{$t('weightAdjBox.adjBmi')}}:</div>
                      <div class="value-div">
                        <div v-if="adjustPerc==0" class="adj-value">--<span v-if="!(disease=='Type 2 Diabetes' || disease==pageNAFLD || disease==pageCancer 
                        || (disease=='PCOS' && condition) || (disease==pageHypertension && condition) )">-</span></div>
                        <div v-if="adjustPerc==5" class="adj-value">{{userData.calc.bmi.adj5}}</div>
                        <div v-if="adjustPerc==10" class="adj-value">{{userData.calc.bmi.adj10}}</div>
                        <div v-if="adjustPerc==15" class="adj-value">{{userData.calc.bmi.adj15}}</div>
                        <div v-if="adjustPerc==20" class="adj-value">{{userData.calc.bmi.adj20}}</div>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col class="reduce-padding" cols="12">
              <div :class="{'adj-bottom-txt-sp' : $i18n.locale=='sp'}" class="adj-bottom-txt"><sup>*</sup><i>{{$t('weightAdjBox.footer')}}</i></div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
    
  </b-row>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    name: "weightAdjustmentBox",
    mounted: function() {
      this.adjustPerc = this.adjustSelection;
    },
    components: {},
    computed: {
      ...mapGetters('userData', ['userData']),
    },
    data() {
      return {
        adjustPerc: 0,
       pageHypertension: this.$t('common.hypertension').toLowerCase(),
       pageCancer: this.$t('common.cancer').toLowerCase(),
       pageNAFLD:this.$t('common.NAFLD'),
       pageinfertility:this.$t('infertility.pageTitle') ,
       pageOsteoarthritis: this.$t('common.osteoarthritis').toLowerCase(),
       pageDyslipidemia: this.$t('common.dyslipidemia').toLowerCase(),
       pageLifeLost:   this.$t('lifelost.pageTitle'), 
       pageDiabetes: this.$t('common.diabetes'),
      };
    },
    props: {
      adjButtons: {
          type: Array,
          default: function() {
            return ['five', 'ten', 'fifteen', 'twenty'];
          }
      },
      disease: {
        type: String,
        required: true
      },
      
      adjustSelection: {
        type: Number,
      },
      btnClickHandler: {
          type: Function,
          default: () => {}
      },
      condition: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      show: function(buttonsArray, button) {
          return !(buttonsArray.indexOf(button) == -1);
      },
      SetAdjustPerc: function(perc) {
          this.adjustPerc = perc;
          this.$emit('adjustPercUpdate', this.adjustPerc);
      },
    },
    
    watch: {
      adjustSelection: function(oldVal, newVal) {
        if(oldVal !== newVal) {
          this.adjustPerc = this.adjustSelection;
        }
      },
    },
  };
</script>


<style lang="scss" scoped>

</style>
